import React from 'react';

import arrayMove from 'array-move';
import AvailableStep from 'containers/AvailableStep';
import { useTranslation } from 'react-i18next';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { v4 as uuidv4 } from 'uuid';

import { collectionsDiffer } from 'components/helpers/objects';

const SortableItem = SortableElement(({ stepId }) => (
  <AvailableStep stepId={stepId} />
));

const SortableList = SortableContainer(({ isSorting, items }) => (
  <ul className='block-list block-list--border-bottom-none tw-relative'>
    {items.map((stepId, index) => (
      <React.Fragment key={`step--${stepId}`}>
        {isSorting && (
          <div className='row-bar--ghost row-bar__ghost--step tw-border-blue-100 tw-bg-blue-025' />
        )}
        <SortableItem index={index} stepId={stepId} />
      </React.Fragment>
    ))}
  </ul>
));

const collapsedItemSpace = 52;

export default function StepList({
  addError,
  containerRef,
  dispatch,
  isSorting,
  isStepsOpen,
  methodSequenceId,
  stepIds,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const handleSortStart = ({ index, node }) => {
    dispatch({
      type: 'START_STEPS_ORDERING',
      methodSequenceId,
      options: { containerRef, node, index, collapsedItemSpace },
    });
  };

  const handleSortEnd = ({ newIndex, oldIndex }) => {
    const orderedStepIds = arrayMove(stepIds, oldIndex, newIndex);
    dispatch({
      type: 'FINISH_STEPS_ORDERING',
      methodSequenceId,
      newOrder: orderedStepIds,
    });
    collectionsDiffer(oldIndex, newIndex) &&
      requestStepMove(stepIds[oldIndex], newIndex);
  };

  const requestStepMove = (stepId, newIndex) => {
    axios
      .patch(`/method_steps/${stepId}/position`, {
        method_step: { position: newIndex + 1 },
      })
      .catch(() =>
        addError(uuidv4(), { fullMessage: i18nTShared('errors.generic') }),
      );
  };

  return (
    <SortableList
      getContainer={() => document.getElementById('main')}
      helperClass='sortable-item--active'
      isOpen={isStepsOpen}
      isSorting={isSorting}
      items={stepIds}
      lockAxis='y'
      lockToContainerEdges={true}
      onSortEnd={handleSortEnd}
      updateBeforeSortStart={handleSortStart}
      useDragHandle={true}
    />
  );
}
